import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const FlexContainer = styled.div<{ isAutoWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: ${({ isAutoWidth }) => (isAutoWidth ? '1' : 'initial')};
  &&&&& [data-test='toggle-button-Recommendations'], // styling the core toggle fails
  &&&&& [data-test='toggle-button-OrderedByField'] {
    height: ${pxToRem(36)};
    i.icon {
      height: unset;
    }
  }
`;
